import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { finishInsertingJob, JobWithUsers } from './jobsSlice';

interface AlertBoxState {
  readonly id: string;
  readonly show: boolean;
  readonly name: string;
  readonly jobOrganization: string;
  readonly job?: JobWithUsers;
}

const initialState: AlertBoxState = {
  id: '',
  show: false,
  name: '',
  jobOrganization: '',
};

const alertBoxSlice = createSlice({
  name: 'alertBox',
  initialState,
  reducers: {
    setShowAlertBox: (state, action: PayloadAction<boolean>) => {
      state.show = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(finishInsertingJob, (state, action) => {
      const job = action.payload;

      state.id = job.id.toString();
      state.name = job.name.toString();
      state.show = true;
      state.jobOrganization = job.sharedWithOrganizationsAsString || '';
      state.job = castDraft(job);
    });
  },
});

export const { setShowAlertBox } = alertBoxSlice.actions;
export const alertBox = alertBoxSlice.reducer;
